export default __webpack_public_path__ + "images/861967692e73cfdab97721d71925eeab.svg";